import React from 'react'
import FinishesContainer from './FinishesContainer'

const Finishes = () => <FinishesContainer data-test="component-finishes" />

export default Finishes
